function cartNotificationAddonRequest(url, payload) {
  payload.sections = ['cart-notification-button', 'cart-icon-bubble'];
  return fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(payload),
  }).then((response) => response.json());
}

function cartNotificationPatchFragments(sections) {
  if (!sections) return;
  ['cart-notification-button', 'cart-icon-bubble'].forEach((id) => {
    const target = document.getElementById(id);
    const html = sections[id];
    if (!target || !html) return;
    const fragment = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (fragment) target.innerHTML = fragment.innerHTML;
  });
}

// Toggle the "more info" panel open/closed.
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('.cart-notification-addon-card__info-toggle');
  if (!toggle) return;

  const card = toggle.closest('.cart-notification-addon-card');
  const panel = card && card.querySelector('.cart-notification-addon-card__info-panel');
  if (!panel) return;

  const isOpen = !panel.hidden;
  panel.hidden = isOpen;
  toggle.setAttribute('aria-expanded', String(!isOpen));
});

// Add or remove the add-on line item when a Yes/No option is chosen.
document.addEventListener('change', (event) => {
  const radio = event.target;
  if (!radio.classList || !radio.classList.contains('cart-notification-addon-option__radio')) return;

  const card = radio.closest('.cart-notification-addon-card');
  if (!card) return;
  const yesRadio = card.querySelector('[data-addon-choice="yes"]');
  const noRadio = card.querySelector('[data-addon-choice="no"]');
  if (!yesRadio) return;

  const variantId = yesRadio.getAttribute('data-addon-variant-id');
  const productTitle = yesRadio.getAttribute('data-addon-for-product') || '';
  if (!variantId) return;

  yesRadio.disabled = true;
  if (noRadio) noRadio.disabled = true;

  let request;
  if (radio.getAttribute('data-addon-choice') === 'yes') {
    request = cartNotificationAddonRequest('/cart/add.js', {
      items: [{ id: variantId, quantity: 1, properties: { 'Voor product': productTitle } }],
    }).then((data) => {
      if (data.status) {
        if (noRadio) noRadio.checked = true;
        console.warn(data.description || data.message);
        return;
      }
      yesRadio.setAttribute('data-addon-line-key', data.key);
      cartNotificationPatchFragments(data.sections);
    });
  } else {
    const lineKey = yesRadio.getAttribute('data-addon-line-key');
    if (!lineKey) {
      yesRadio.disabled = false;
      if (noRadio) noRadio.disabled = false;
      return;
    }
    request = cartNotificationAddonRequest('/cart/change.js', { id: lineKey, quantity: 0 }).then((data) => {
      yesRadio.removeAttribute('data-addon-line-key');
      cartNotificationPatchFragments(data.sections);
    });
  }

  request
    .catch((error) => {
      console.warn(error);
    })
    .finally(() => {
      yesRadio.disabled = false;
      if (noRadio) noRadio.disabled = false;
    });
});
